import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./ImageGallery.css";

export default function ImageGallery({ images = [], carName }) {
    const [current, setCurrent] = useState(0);
    const [pause, setPause] = useState(false);

    useEffect(() => {
        if (pause || images.length <= 1) return;

        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 2000);

        return () => clearInterval(interval);
    }, [pause, images.length]);

    const nextImage = () => {
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setCurrent((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    return (
        <section
            className="gallery-section"
            onMouseEnter={() => setPause(true)}
            onMouseLeave={() => setPause(false)}
        >
            <div className="gallery-main">

                <button
                    className="gallery-btn left"
                    onClick={prevImage}
                >
                    <ChevronLeft size={30} />
                </button>

                <img
                    src={images[current]}
                    alt={carName}
                    className="gallery-main-image"
                />

                <button
                    className="gallery-btn right"
                    onClick={nextImage}
                >
                    <ChevronRight size={30} />
                </button>

                <div className="image-counter">
                    {current + 1} / {images.length}
                </div>

            </div>

            <div className="gallery-thumbnails">

                {images.map((image, index) => (

                    <div
                        key={index}
                        className={`thumbnail ${current === index ? "active" : ""
                            }`}
                        onClick={() => setCurrent(index)}
                    >

                        <img
                            src={image}
                            alt={`${carName}-${index}`}
                        />

                    </div>

                ))}

            </div>

        </section>
    );
}